import * as React from 'react';

import { CelebrationState } from '@ReactComponents/Shared/CelebrationState/CelebrationState';

interface ISignUpWelcomeScreenProps {
  activateCompany: () => void;
  bodyText?: string;
}

export const SignUpWelcomeScreen: React.FC<ISignUpWelcomeScreenProps> = ({ activateCompany, bodyText }) => {
  return (
    <CelebrationState
      headerText="Welcome to Emburse Spend"
      bodyText={
        bodyText ??
        'Thank you for submitting more information about your business. Your account has been successfully created and is ready to use. '
      }
      buttonText="start using emburse spend"
      onClick={activateCompany}
    />
  );
};
